export const avatarSizes = {
  xs: {width: '24', height: '24'},
  small: {width: '32', height: '32'},
  medium: {width: '96', height: '96'},
  'sm-med': {width: '65', height: '65'},
  large: {width: '110', height: '110'},
};

export type AvatarSizesTypes = keyof typeof avatarSizes;